import { gsap } from 'gsap';
import getEvent from '../../functions/getEvent';
import isInViewport from '../../functions/isInViewport';
const Content = (el, activeItem) => {
    const videoPlayersContainer = el.querySelector(
        '.js-video-playlist-players'
    );
    const videoPlayer = el.querySelector('.video-player');
    const embeddedVideoPlayer = el.querySelector('.embedded-video-player');
    const showMoreEl = el.querySelector('.show-more');
    const updateContent = (activeItem) => {
        const newTitle = activeItem.querySelector('.playlist__title').innerHTML;
        const newBody = activeItem.getAttribute('data-content');
        el.querySelector('.js-video-playlist-title').innerHTML = newTitle;
        el.querySelector('.js-video-playlist-body').innerHTML = newBody;
        activeItem.dataset.videoId
            ? updateVideoPlayer(activeItem)
            : updateEmbeddedVideoPlayer(activeItem);
        updateShowMore();
        isContentInView(
            activeItem.dataset.videoId ? videoPlayer : embeddedVideoPlayer
        );
    };
    const updateEmbeddedVideoPlayer = (activeItem) => {
        if (!activeItem.dataset.videoUrl) return;
        const event = getEvent('update');
        const obj = {
            url: activeItem.getAttribute('data-video-url'),
            coverImage: activeItem.getAttribute('data-video-cover'),
            label: activeItem.getAttribute('data-video-label'),
            altText: activeItem.getAttribute('data-video-alt'),
            name: activeItem.getAttribute('data-video-name')
        };
        event.data = obj;
        videoPlayersContainer.dataset.activeVideoPlayer = 'embedded';
        embeddedVideoPlayer && embeddedVideoPlayer.dispatchEvent(event);
        videoPlayer && videoPlayer.dispatchEvent(getEvent('pause'));
    };
    const updateVideoPlayer = (activeItem) => {
        const event = getEvent('update');
        const obj = {
            id: activeItem.getAttribute('data-video-id'),
            coverImage: activeItem.getAttribute('data-video-cover'),
            label: activeItem.getAttribute('data-video-label')
        };
        event.data = obj;
        videoPlayersContainer.dataset.activeVideoPlayer = 'youtube';
        videoPlayer && videoPlayer.dispatchEvent(event);
        embeddedVideoPlayer &&
            embeddedVideoPlayer.dispatchEvent(getEvent('pause'));
    };
    const updateShowMore = () => {
        const event = getEvent('update');
        showMoreEl.dispatchEvent(event);
    };
    const isContentInView = (el) => {
        if (!isInViewport(el)) {
            gsap.to(window, {
                duration: 0.3,
                scrollTo: { y: el, offsetY: 16 }
            });
        }
    };
    const init = () => {
        if (activeItem) {
            updateContent(activeItem);
        }
    };
    init();
};
export default Content;
